import axios from 'axios';

export const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
});
